// extracted by mini-css-extract-plugin
export default {"searchChoiceButton":"catalog-SearchChoiceButton-module__searchChoiceButton"};